import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/myShopApi'

class Store {
  @observable list = []
  @observable total = 1
  @observable
  pagination = {
    current: 1,
    pageSize: 10,
    total: 1
  }

  @observable this_month_count = 0
  @action
  getList = async page => {
    const { pagination } = this
    let params = {
      per_page: 10,
      page: page ? page : pagination.current
    }
    let {
      data: { list, total_count, this_month_count }
    } = await Api.violate(params)
    runInAction(() => {
      this.list = list
      this.this_month_count = this_month_count
      this.pagination.total = +total_count
    })
  }

  @action
  setPage = page => {
    this.pagination.current = page.current
    this.getList(page.current)
  }
}
export default new Store()
